module.exports = __webpack_public_path__ + "static/img/spread3-3.7e8a885.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread3-3.jpg
// module id = top5
// module chunks = 1